import React from 'react';
import { SettingsPage } from '../../../components/SettingsPage/SettingsPage';
import { LogCollectionSetting } from '../../../customSettings/LogCollectionSetting/LogCollectionSetting';
import { COLLECT_LOGS_PAGE_STRINGS } from '../SupportAndTroubleshootStrings';
import './CollectLogsPage.css';

interface CollectLogsPageProps {
	title: string;
	description?: string;
}

export const CollectLogsPage: React.FC<CollectLogsPageProps> = ({ title }) => {
	return (
		<SettingsPage
			title={title}
			settings={
				<>
					<p className="collect-logs-page-description">
						{COLLECT_LOGS_PAGE_STRINGS.PAGE_DESCRIPTION}
					</p>
					<LogCollectionSetting />
				</>
			}
		/>
	);
};
